module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/mainData/index'
        })
      }
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "rgroup",
    staticStyle: {
      "margin-left": "60px"
    },
    on: {
      "change": _vm.changeGet
    },
    model: {
      value: (_vm.getWhich),
      callback: function($$v) {
        _vm.getWhich = $$v
      },
      expression: "getWhich"
    }
  }, [_c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "原生广告"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "买量详情"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    staticClass: "radio",
    attrs: {
      "label": "分发详情"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeGet
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "请选择",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非矩阵",
      "value": "0"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": _vm.pdata.sdate,
      "end-placeholder": _vm.pdata.edate,
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '原生广告'),
      expression: "getWhich=='原生广告'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "height": "600",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_visit_pv",
      "label": "展示数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_click_pv",
      "label": "点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "原生收入",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_click_per",
      "label": "单次点击收益",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_visit_pv",
      "label": "视频广告展示数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_pv",
      "label": "视频广告点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_income",
      "label": "视频收入",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_per",
      "label": "点击率",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "video_click_per",
      "label": "单次点击收益",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '买量详情'),
      expression: "getWhich=='买量详情'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.bdata.list,
      "height": "600",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "买量产品",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "买量日期",
      "align": "center",
      "min-width": "100",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "买量金额",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateBM(s.row.id, s.$index, s.row)
            }
          }
        }, [_vm._v(_vm._s(s.row.expenses_cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buy_user",
      "label": "买量用户",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateBM(s.row.id, s.$index, s.row)
            }
          }
        }, [_vm._v(_vm._s(s.row.buy_user))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roi",
      "label": "回收预测",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day_0",
      "label": "当天回本",
      "align": "center"
    }
  }), _vm._v(" "), _vm._l((30), function(i) {
    return _c('el-table-column', {
      key: i,
      attrs: {
        "prop": 'day_' + i,
        "label": i + '天回本',
        "align": "center"
      }
    })
  })], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getWhich == '分发详情'),
      expression: "getWhich=='分发详情'"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.mdata.list,
      "height": "800",
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued",
      "label": "是否矩阵",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.issued == 1 ? "矩阵" : "非矩阵"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_pv",
      "label": "点击次数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "label": "点击人数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "点击成功人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.clickok_uv || 0))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新买量数据",
      "visible": _vm.updateBuyMoney,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.updateBuyMoney = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.updateGroup
    }
  }, [_c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "买量金额",
      "prop": "expenses_cost"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "autofocus": "",
      "placeholder": "买量金额",
      "clearable": ""
    },
    model: {
      value: (_vm.updateGroup.expenses_cost),
      callback: function($$v) {
        _vm.$set(_vm.updateGroup, "expenses_cost", $$v)
      },
      expression: "updateGroup.expenses_cost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inline",
    attrs: {
      "label": "买量用户",
      "prop": "buy_user"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "买量用户",
      "clearable": ""
    },
    model: {
      value: (_vm.updateGroup.buy_user),
      callback: function($$v) {
        _vm.$set(_vm.updateGroup, "buy_user", $$v)
      },
      expression: "updateGroup.buy_user"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updateBuyMoney = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sUpdate
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71122f54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/totalDetail.vue
// module id = 1142
// module chunks = 2